
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM14.7809 7.04948C15.0376 7.30606 15.0376 7.7221 14.781 7.97874L9.80818 12.9527C9.55162 13.2094 9.13561 13.2094 8.87896 12.9529L6.10693 10.182C5.85027 9.92548 5.85018 9.50944 6.10673 9.25277C6.36329 8.99611 6.77933 8.99602 7.036 9.25258L9.34334 11.559L13.8517 7.04959C14.1082 6.79295 14.5243 6.7929 14.7809 7.04948Z","fill":"#8338EC"}})])
          )
        }
      }
    